import { REGIONS_WITH_COUNTRIES } from "./dropdownOptions";

export interface CountryEntry {
  name: string;
  slug: string;
  region: string;
}

export function slugify(name: string): string {
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip accents
    .replace(/['’`]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Master list = REGIONS_WITH_COUNTRIES, deduped by country name (some appear
// in multiple region buckets, e.g. Japan in Asia-Pacific & East Asia).
const seen = new Map<string, CountryEntry>();
for (const [region, list] of Object.entries(REGIONS_WITH_COUNTRIES)) {
  for (const name of list) {
    if (!seen.has(name)) {
      seen.set(name, { name, slug: slugify(name), region });
    }
  }
}

export const COUNTRIES: CountryEntry[] = Array.from(seen.values()).sort((a, b) =>
  a.name.localeCompare(b.name),
);

export const COUNTRIES_BY_SLUG: Record<string, CountryEntry> = Object.fromEntries(
  COUNTRIES.map((c) => [c.slug, c]),
);

export function countryFromSlug(slug: string | undefined): CountryEntry | null {
  if (!slug) return null;
  return COUNTRIES_BY_SLUG[slug.toLowerCase()] ?? null;
}

export interface RegionGroup {
  region: string;
  countries: CountryEntry[];
}

export const COUNTRIES_BY_REGION: RegionGroup[] = Object.keys(REGIONS_WITH_COUNTRIES).map(
  (region) => ({
    region,
    countries: COUNTRIES.filter((c) => c.region === region).sort((a, b) =>
      a.name.localeCompare(b.name),
    ),
  }),
);
